import { ArticleFields } from 'src/shared/ArticleBase.types';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C60NewsDetailsProps = RenderingProps<ArticleFields, C60NewsDetailsParams>;

export type C60NewsDetailsParams = AnchorTargetParams & TranslationOptionsParams;
